var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.75H8.88438L11.1263 8.50875L10.25 7.625L6.5 11.375L10.25 15.125L11.1263 14.2406L8.88625 12H16.5C17.4946 12 18.4484 12.3951 19.1517 13.0983C19.8549 13.8016 20.25 14.7554 20.25 15.75C20.25 16.7446 19.8549 17.6984 19.1517 18.4017C18.4484 19.1049 17.4946 19.5 16.5 19.5H11.5V20.75H16.5C17.8261 20.75 19.0979 20.2232 20.0355 19.2855C20.9732 18.3479 21.5 17.0761 21.5 15.75C21.5 14.4239 20.9732 13.1521 20.0355 12.2145C19.0979 11.2768 17.8261 10.75 16.5 10.75Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.0d066f0e135f41084883b904c6096691.svg";
export { ForwardRef as ReactComponent };